import React from 'react';
import PasswordSetupForm from '@/components/PasswordSetupForm';

/**
 * Landing page for invited users. Reads a `?token=` query param and calls
 * POST /api/auth/set-password. On success routes back to /login with a
 * `?welcome=true` flag so the login page can show a friendly banner.
 */
export default function SetPasswordPage() {
  return (
    <PasswordSetupForm
      title="Set your password"
      subtitle="Welcome to SHINE Ops Hub. Choose a password to activate your account."
      endpoint="/api/auth/set-password"
      successMessage="Password set — you can now sign in."
      redirectQuery="welcome=true"
      submitLabel="Activate account"
      testIdPrefix="set-password"
    />
  );
}
